import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// ── Prevent search engine discovery ─────────────────────────────
function preventSearchDiscovery() {
  const robotsMeta = document.createElement('meta');
  robotsMeta.name = 'robots';
  robotsMeta.content = 'noindex, nofollow, noarchive, nosnippet, noimageindex';
  document.head.appendChild(robotsMeta);
  const googlebotMeta = document.createElement('meta');
  googlebotMeta.name = 'googlebot';
  googlebotMeta.content = 'noindex, nofollow, noarchive, nosnippet';
  document.head.appendChild(googlebotMeta);
  const cacheMeta = document.createElement('meta');
  cacheMeta.httpEquiv = 'pragma';
  cacheMeta.content = 'no-cache';
  document.head.appendChild(cacheMeta);
  const existingDesc = document.querySelector('meta[name="description"]');
  if (existingDesc) existingDesc.remove();
  const existingKeywords = document.querySelector('meta[name="keywords"]');
  if (existingKeywords) existingKeywords.remove();
}
// ── Content Protection ──────────────────────────────────────────
function enableContentProtection() {
  // Disable right-click context menu
  document.addEventListener('contextmenu', e => {
    e.preventDefault();
    return false;
  });
  // Disable copy, cut, paste
  document.addEventListener('copy', e => e.preventDefault());
  document.addEventListener('cut', e => e.preventDefault());
  document.addEventListener('paste', e => e.preventDefault());
  // Disable drag and drop (prevents dragging images/text out)
  document.addEventListener('dragstart', e => e.preventDefault());
  document.addEventListener('drop', e => e.preventDefault());
  // Block keyboard shortcuts for copying, saving, printing, dev tools, view source
  document.addEventListener('keydown', e => {
    const key = e.key.toLowerCase();
    // Ctrl/Cmd + C (copy), X (cut), V (paste), S (save), P (print), U (view source), A (select all)
    if ((e.ctrlKey || e.metaKey) && ['c', 'x', 'v', 's', 'p', 'u', 'a'].includes(key)) {
      e.preventDefault();
      return false;
    }
    // Ctrl/Cmd + Shift + I (dev tools), J (console), C (inspect element)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j', 'c'].includes(key)) {
      e.preventDefault();
      return false;
    }
    // F12 (dev tools)
    if (e.key === 'F12') {
      e.preventDefault();
      return false;
    }
    // PrintScreen
    if (e.key === 'PrintScreen') {
      e.preventDefault();
      // Clear clipboard after PrintScreen attempt
      navigator.clipboard?.writeText('').catch(() => {});
      return false;
    }
  });
  // Detect visibility change (tab switching during screen recording)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      document.title = '🔒 Protected Content';
    } else {
      document.title = 'Festeryga Law — Intelligence Platform';
    }
  });
  // Attempt to detect screen capture API usage
  if (navigator.mediaDevices) {
    const originalGetDisplayMedia = navigator.mediaDevices.getDisplayMedia;
    if (originalGetDisplayMedia) {
      navigator.mediaDevices.getDisplayMedia = function () {
        console.warn('Screen capture is not permitted on this platform.');
        return Promise.reject(new Error('Screen capture blocked by content protection policy.'));
      };
    }
  }
}
preventSearchDiscovery();
enableContentProtection();
// ────────────────────────────────────────────────────────────────
const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
createRoot(container).render(<App data-id="element-120" />);